/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Case_Section_Documents_DescriptionInputs */

const en_case_section_documents_description = /** @type {(inputs: Case_Section_Documents_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} document categories. Drop one or more files per slot.`)
};

const pt_br2_case_section_documents_description = /** @type {(inputs: Case_Section_Documents_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} categorias de documentos. Arraste um ou mais arquivos por slot.`)
};

/**
* | output |
* | --- |
* | "{count} document categories. Drop one or more files per slot." |
*
* @param {Case_Section_Documents_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_documents_description = /** @type {((inputs: Case_Section_Documents_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Documents_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_documents_description(inputs)
	return pt_br2_case_section_documents_description(inputs)
});